module.exports = __webpack_public_path__ + "img/img02.a4065a56.png";